import { gql, useQuery, QueryHookOptions } from '@apollo/client';
import { GAME_TYPES_TYPE, OPERAND_TYPE } from '../../../../constants/constants';
import { EGymAssessmentMode } from '../../../../utils/gymUtils';

export const query = gql`
  query AssessmentPracticeGamesByUserHiveAndGameType($userId: String!, $gameType: GameType) {
    assessmentPracticeGamesByUserHiveAndGameType(userId: $userId, gameType: $gameType) {
      _id
      userId
      gameType
      assessmentMode
      played
      highScore
      correctCount
      questionsTaken
      timeSec
      correctAnswers {
        left {
          a
          x
          b
          c
          y
        }
        right {
          a
          x
          b
          c
          y
        }
      }
      wrongAnswers {
        left {
          a
          x
          b
          c
          y
        }
        right {
          a
          x
          b
          c
          y
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export interface GymAssessmentPracticeGameType {
  _id: string;
  userId: string;
  gameType: GAME_TYPES_TYPE;
  assessmentMode: EGymAssessmentMode;
  played: number;
  highScore: number;
  correctCount: number;
  questionsTaken: number;
  timeSec: number;
  correctAnswers: Answer[][];
  wrongAnswers: Answer[][];
  createdAt: string;
  updatedAt: string;
}

export interface Answer {
  left: OPERAND_TYPE;
  right: OPERAND_TYPE;
}

export interface RequestType {
  userId: string;
  gameType?: GAME_TYPES_TYPE;
}

export interface QueryType {
  assessmentPracticeGamesByUserHiveAndGameType: GymAssessmentPracticeGameType[];
}

export function useGymAssessmentPracticeGamesQuery(
  request: RequestType,
  options?: QueryHookOptions<QueryType, RequestType>,
) {
  return useQuery<QueryType, RequestType>(query, {
    variables: request,
    ...options,
  });
}
